import cn from 'clsx';
import { MenuItem } from '@v2/shared/lib/types';
import { User } from '@v2/shared/lib/types';
import { HelpLink, MenuPanel, FullScreenDialog } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import { faUser, faPhone, faCommentQuestion } from '@fortawesome/pro-solid-svg-icons';

import AccountLink from './AccountLink';
import AccountOverview from './AccountOverview';
import { useSite } from '@v2/shared/lib/site';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  accountLinks: MenuItem[];
  user: User | null | undefined;
};

export default function AccountDialog({ isOpen, toggle, close, user, accountLinks }: Props) {
  const { buildUrl } = useUrlGenerator();
  const { country } = useSite();

  return (
    <FullScreenDialog slideInFrom="right" isOpen={isOpen} toggle={toggle} close={close} title="Account">
      {user && (
        <MenuPanel>
          <AccountOverview user={user} />
          <div className="grid grid-cols-2 gap-4">
            {accountLinks.map(({ id, href, title, icon }) => (
              <AccountLink key={id} href={href} title={title} icon={icon} />
            ))}
          </div>
        </MenuPanel>
      )}
      {!user && (
        <MenuPanel>
          <div className="grid grid-cols-3 gap-4">
            <HelpLink href={buildUrl('/customer?xCmd=login')} icon={faUser} title="Sign In" />
            <HelpLink href={buildUrl('/contact')} icon={faPhone} title="Contact Us" />
            <HelpLink href={buildUrl('/help')} icon={faCommentQuestion} title="Help" />
          </div>
        </MenuPanel>
      )}
      {user && (
        <MenuPanel>
          <MenuPanel.Title title="Support Center" />
          <div className="grid grid-cols-2 gap-4">
            <HelpLink href={buildUrl('/contact')} icon={faPhone} title="Contact Us" />
            <HelpLink href={buildUrl('/help')} icon={faCommentQuestion} title="Help" />
          </div>
        </MenuPanel>
      )}
      <MenuPanel flush>
        {country === 'US' && <MenuPanel.Item href={buildUrl('/bulk-order')} title="Bulk Orders" />}
        {user && <MenuPanel.Item href={buildUrl('/customer?xCmd=logout')} title="Log Out" />}
      </MenuPanel>
    </FullScreenDialog>
  );
}
